// Ready-made home meals menu ("אוכל ביתי במשלוחים"), transcribed from the printed menu.
// Prices are in ₪. `note` is the portion size shown next to the price.
export const READY_MEALS_MENU = [
  {
    id: "mains",
    title: "מנות עיקריות",
    items: [
      {
        name: "קציצות עוף שילדים אוהבים",
        price: 80,
        note: "12 קציצות",
        description: "חזה עוף טרי בתוספת בצל, פירורי לחם ושום, מתובל בעדינות, מוגש ברוטב עגבניות",
      },
      {
        name: "קציצות של בית",
        price: 90,
        note: "12 קציצות",
        description: "בשר בקר טרי טחון בתוספת בצל, שום, פטרוזיליה וכוסברה. המנה מוגשת ברוטב עגבניות עם בטטה",
      },
      {
        name: "שניצלים דקדקים",
        price: 80,
        note: "9 שניצלים",
        description: "חזה עוף טרי, מטוגן בשמן עמוק. מומלץ לחמם בתנור",
      },
      {
        name: "חזה עוף נתח טרי",
        price: 80,
        note: "9 נתחים",
        description: "נתח טרי של עוף מושרה במרינדה",
      },
      {
        name: "בולונז אמיתי",
        price: 90,
        note: "750 גרם",
        description: "בשר בקר טרי טחון בתוספת בצל, שום ורוטב עגבניות עשיר, מתובל בעדינות",
      },
      {
        name: "המבורגר של מסעדות",
        price: 180,
        note: "4 המבורגרים",
        description: "מגיע קפוא עם לחמניה בצד (משקל המבורגר – 200 גרם)",
      },
      {
        name: "כנפיים בתנור",
        price: 95,
        note: "1 ק״ג",
        description: "כנפי עוף חצויות ברוטב גריל, צלויות בתנור",
      },
      {
        name: "שווארמה פרגית",
        price: 125,
        description: "רצועות פרגית חתוכות דק בתערובת תבלינים ״צהובה״ מושלמת",
      },
      {
        name: "בשר מפורק",
        price: 150,
        note: "3 מנות",
        description: "נתח בקר איכותי וטרי, מפורק לחוטים, נימוח ואוורירי",
      },
    ],
  },
  {
    id: "specials",
    title: "מיוחדים",
    items: [
      {
        name: "לביבות בטטה של אורנה ואלה",
        price: 100,
        description: "מחית בטטה בתוספת מעט קמח, עשויות על פלנצ'ה בחמאה, מוגשות עם מטבל שמנת חמוצה ועירית",
      },
      {
        name: "קדרת עוף",
        price: 225,
        note: "6 סועדים",
        description: "עוף שלם טרי מפורק בתוספת ירקות שורש, תפוח אדמה, תבלינים ועשבי תיבול",
      },
      {
        name: "חמין משובח",
        price: 300,
        note: "4 סועדים",
        description: "שעועית לבנה וחומה, גריסים וגרגרי חומוס בתוספת תפוחי אדמה, בשר אסאדו ונתח בקר מס' 2",
      },
      {
        name: "קדרת בקר",
        price: 305,
        note: "4 סועדים",
        description: "נתחי בקר מובחר בתוספת בצל, גזר, שום, פלפל אדום ותפוח אדמה, מבושל בציר בקר",
      },
      {
        name: "גריל עוף שזוף שזוף",
        price: 225,
        description: "עוף מפורק בגריל, מתובל היטב, עם מלא תפוחי אדמה וגזר",
      },
      {
        name: "ניוקי עבודת יד",
        price: 100,
        note: "מינימום 4 מנות",
        description: "עם בשר מפורק, או ברוטב חמאה, יוגורט ושמנת עם מרווה ובזיליקום",
      },
      {
        name: "לזניה גבינות",
        price: 260,
        description: "לזניה עם 3 סוגי גבינה איכותית, ברוטב עגבניות",
      },
      {
        name: "אנטיפסטי",
        price: 195,
        note: "מינימום 6 מנות",
        description: "חציל, קישוא, פלפל אדום ובטטה קלויים בטאבון, עם שמן זית וחומץ בלסמי",
      },
    ],
  },
  {
    id: "soups",
    title: "מרקים",
    items: [
      {
        name: "מרק כתום",
        price: 100,
        description: "דלעת, גזר וכרישה מבושלים בציר ירקות, במרקם חלק",
      },
      {
        name: "מרק עדשים",
        price: 100,
        description: "בצל, קישוא, מעט שום ועדשים כתומות מבושלים בציר ירקות, במרקם חלק",
      },
      {
        name: "מרק בצל צרפתי",
        price: 110,
        description: "רצועות בצל צרובות בחמאה עם ציר ירקות וטימין, בליווי קרוטונים",
      },
      {
        name: "מרק עגבניות כפרי",
        price: 110,
        description: "עגבניות, שום ובצל צלויים בתנור בשמן זית עם עשבי תיבול, בציר ירקות, במרקם גס",
      },
      {
        name: "מרק חרירה צמחוני",
        price: 100,
        description: "מגוון ירקות שורש, עם גרגרי חומוס ולחיות לימון",
      },
      {
        name: "מרק ירוק",
        price: 110,
        description: "סלרי, בצל, קישוא, תפוח אדמה וגזר, עם מלא ירק: פטרוזיליה, כוסברה ושמיר",
      },
    ],
  },
  {
    id: "vegan",
    title: "הטבעוני שלנו",
    items: [
      {
        name: "קוסקוס פגז",
        price: 100,
        description: "מוכן באהבה, בעבודת יד, בתוספת ציר ירקות טבעוני",
        extra: "אפשר להחליף בציר עוף בתוספת 45 ₪",
      },
      {
        name: "הקינואה של יעלי",
        price: 90,
        description: "קינואה ועדשים שחורות עם כורכום ומעט כמון, מלח, פלפל ושמן זית",
      },
      {
        name: "הקציצה הטבעונית של עדי",
        price: 95,
        description: "על בסיס עדשים שחורות, סלק, תמר, גזר, קישוא, בצל ושום, בליווי טחינה ירוקה",
      },
      {
        name: "השווארמה הטבעונית של חוויר",
        price: 95,
        description: "שווארמה על בסיס סויה בתיבול ״הצהובים״, בליווי בצל זהב",
      },
      {
        name: "אורז על מלא",
        price: 90,
        description: "אורז מלא עם בצל מטוגן, אפונה וגזר",
      },
    ],
  },
  {
    id: "sides",
    title: "תוספות",
    items: [
      { name: "פירה קטיפתי", price: 75 },
      { name: "אפונה / שעועית ברוטב עגבניות", price: 75 },
      { name: "אורז גרגיר גרגיר", price: 70 },
    ],
  },
]
